document.addEventListener("DOMContentLoaded", function () {
  const link = document.getElementById("size-chart-link");
  const modal = document.getElementById("size-chart-modal");

  if (link && modal) {
    link.addEventListener("click", function (e) {
      e.preventDefault(); // ⬅️ stops page jump
      modal.style.display = "block";
    });

    modal.addEventListener("click", function (e) {
      if (e.target === modal) {
        modal.style.display = "none";
      }
    });
  }
});